'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  margin: 0;\n  padding: 6px 10px;\n  cursor: pointer;\n  color: ', ';\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  span {\n    margin-left: 15px;\n    color: ', '\n  }\n'], ['\n  margin: 0;\n  padding: 6px 10px;\n  cursor: pointer;\n  color: ', ';\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  span {\n    margin-left: 15px;\n    color: ', '\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SortItem = _styledComponents2.default.span(_templateObject, _color2.default.grey_main, _color2.default.blue_accent);

var MozartNavigationSort = function (_Component) {
  _inherits(MozartNavigationSort, _Component);

  function MozartNavigationSort(props) {
    _classCallCheck(this, MozartNavigationSort);

    var _this = _possibleConstructorReturn(this, (MozartNavigationSort.__proto__ || Object.getPrototypeOf(MozartNavigationSort)).call(this, props));

    _this.state = {
      items: []
    };
    _this.state.items = _this.getInitData();
    return _this;
  }

  _createClass(MozartNavigationSort, [{
    key: 'getInitData',
    value: function getInitData() {
      var items = this.props.items;

      var itemsData = [];
      items.forEach(function (item) {
        var itemData = { name: item.name, value: item.value, selected: item.selected ? item.selected : false, defaultValue: item.defaultValue ? item.defaultValue : false };
        if (item.defaultValue) {
          itemData.sort = item.defaultValue === 'asc' || item.defaultValue === 'desc' ? item.defaultValue : false;
        } else {
          if (typeof item.value === 'string') {
            itemData.sort = false;
          } else {
            itemData.sort = 'desc';
          }
        }
        itemsData.push(itemData);
      });
      return itemsData;
    }
  }, {
    key: 'getItems',
    value: function getItems() {
      var _this2 = this;

      var _props = this.props,
          itemStyle = _props.itemStyle,
          itemSelectedStyle = _props.itemSelectedStyle;

      var DATA = [];
      this.state.items.forEach(function (item) {
        DATA.push(_react2.default.createElement(
          SortItem,
          {
            key: item.name,
            onClick: _this2.handleSelect.bind(_this2, item),
            style: item.selected ? _extends({}, itemSelectedStyle, { borderRadius: '5px' }) : itemStyle },
          item.name,
          item.selected && item.sort && item.sort === 'asc' && _react2.default.createElement('span', { className: 'icon-Up' }),
          item.selected && item.sort && item.sort === 'desc' && _react2.default.createElement('span', { className: 'icon-Down' })
        ));
      });
      return DATA;
    }
  }, {
    key: 'handleSelect',
    value: function handleSelect(selectedItem) {
      var onClick = this.props.onClick;

      var value = '';
      this.state.items.forEach(function (item) {
        if (item.value === selectedItem.value) {
          item.selected = true;
          if (item.sort) {
            item.sort = item.sort === 'asc' ? 'desc' : 'asc';
            value = item.value[item.sort];
          } else {
            value = item.value;
          }
          if (onClick) {
            onClick(value);
          }
        } else {
          item.selected = false;
        }
      });
      this.setState({ items: this.state.items });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          style = _props2.style,
          themeId = _props2.themeId;

      return _react2.default.createElement(
        'p',
        { 'data-qa': this.props.testId, style: style, 'data-theme': themeId },
        this.getItems()
      );
    }
  }]);

  return MozartNavigationSort;
}(_react.Component);

MozartNavigationSort.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  items: _propTypes2.default.array,
  style: _propTypes2.default.object,
  itemStyle: _propTypes2.default.object,
  itemSelectedStyle: _propTypes2.default.object,
  onClick: _propTypes2.default.func
};
MozartNavigationSort.defaultProps = {
  testId: 'MozartNavigationSort',
  themeId: 'MozartNavigationSort',
  items: [],
  style: {},
  itemStyle: {},
  itemSelectedStyle: { border: '1px solid ' + _color2.default.blue_accent }
};
exports.default = MozartNavigationSort;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartNavigationSort/MozartNavigationSort.js
// module id = 1881
// module chunks = 1